// extracted by mini-css-extract-plugin
export default {"barLabel":"task-list_barLabel__g51jA","barLabelOutside":"task-list_barLabelOutside__bhrxO"};